import { render, staticRenderFns } from "./text-tt.vue?vue&type=template&id=4997dbe6&"
import script from "./text-tt.vue?vue&type=script&lang=js&"
export * from "./text-tt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports